/* neu-lab.js — shared index-driven filter engine for collection + search pages.
   Extracted from neu-filter-collection.liquid so search reuses the exact same rail/filters/sort/grid.
   Config comes from #shopGrid data-* attributes (data-scope: catalog|collection|search). */
(function () {
  var root = document.getElementById('shopGrid'); if (!root) return;
  var FALLBACK = root.getAttribute('data-fallback-img');
  var SCOPE = root.getAttribute('data-scope');
  var COLLECTION_URL = root.getAttribute('data-collection-url');
  var grid = document.getElementById('labGrid');
  var filterRoot = document.getElementById('labFilterRoot');
  var countEl = document.getElementById('labCount');
  var emptyEl = document.getElementById('labEmpty');
  var moreBtn = document.getElementById('labMore');
  var sortSel = document.getElementById('labSort');
  var PER = 24;                                   // task 86e33ndh5: page size for numbered pagination
  var ITEMS = [], TAX = null, page = 1, filtered = [];

  function money(n) { return '$' + Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function mtrim(n) { return money(n).replace('.00', ''); }   // task 86e2xdz6w: drop the ".00" (our price never has cents; few compares do)
  function lc(s) { return String(s).toLowerCase(); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var BADGE_C = { scratch: { bc: 'var(--c-scratch)', bt: '#fff' }, open: { bc: 'var(--c-open)', bt: 'var(--navy)' }, refurb: { bc: 'var(--orange)', bt: '#fff' }, new: { bc: 'var(--c-newbox)', bt: '#fff' } };
  var COND_LABEL = { new: { cond: 'new', label: 'New in Box' }, cr: { cond: 'refurb', label: 'Certified Refurb' }, ob: { cond: 'open', label: 'Open Box' }, sdmin: { cond: 'scratch', label: 'Scratch & Dent · Minor' }, sdmod: { cond: 'scratch', label: 'Scratch & Dent · Moderate' }, sdmaj: { cond: 'scratch', label: 'Scratch & Dent · Major' } };

  // Scope the index to THIS collection. Master/huge collections use the whole index;
  // others fetch their membership (product ids) and intersect — covers ALL products in the collection.
  function catFromHandle(h) {
    // "washers-dryers" = the laundry-family bucket (not one category, not everything). certified-refurbished-
    // washers-dryers should show ONLY washers/dryers/sets, not every refurb category (task 86e2965p3).
    if (h.indexOf('washers-dryers') > -1 || h.indexOf('washers-and-dryers') > -1) return ['WASH', 'DRY', 'WDSET', 'LC', '2IN1'];
    // ORDER MATTERS: specific handles must precede generic substrings they contain.
    // "dishwasher" before "washer" (else "dishwashers" matches 'washer' → WASH — task 86e2a5gah).
    var map = [['washer-dryer', 'WDSET'], ['washer-and-dryer', 'WDSET'], ['wd-set', 'WDSET'], ['laundry-center', 'LC'], ['all-in-one', '2IN1'], ['dishwasher', 'DW'], ['refrigerator', 'REF'], ['fridge', 'REF'], ['freezer', 'FRZ'], ['wall-oven', 'WAL'], ['washer', 'WASH'], ['dryer', 'DRY'], ['range', 'RNG'], ['stove', 'RNG'], ['microwave', 'MCR'], ['cooktop', 'CKT'], ['icemaker', 'ICE'], ['ice-maker', 'ICE'], ['water-heater', 'WHTR'], ['grill', 'GRILL'], ['vent', 'VENT'], ['air-condition', 'AC']];
    for (var i = 0; i < map.length; i++) if (h.indexOf(map[i][0]) > -1) return map[i][1];
    return null;
  }
  // Curated & brand-scoped collections whose HANDLE happens to contain a category word (e.g. "most-popular-refrigerators",
  // "neu-preferred-washers", "asko-dishwashers") are a hand-picked / single-brand SUBSET — not the whole category — so
  // they must KEEP their own membership scope (products.json) instead of loading the full index + pre-selecting the broad
  // category. Patterns cover future most-*/most-wanted-*/all-neu-picks-*/neu-preferred-* collections automatically;
  // brand+category one-offs are listed explicitly. (SOP rule 2: the page injects its own property — here it's membership.)
  function forceMembership(h) {
    return /^most-popular-|^most-wanted-|^all-neu-picks-|^neu-preferred/.test(h) || h === 'asko-dishwashers';
  }
  async function scopeItems(all) {
    if (SCOPE === 'catalog') return all;
    // Search: scope the in-stock index to products matching the query (all terms must appear in
    // title/brand). Gives the search page the SAME dynamic rail as collections, in-stock only. (Option B)
    if (SCOPE === 'search') {
      var raw = root.getAttribute('data-search-query') || '';
      var q = raw.toLowerCase().replace(/[^\w\s]+/g, ' ').trim();
      if (!q) return [];
      var terms = q.split(/\s+/).filter(Boolean);
      // (a) keyword match on title + brand — good for product-name / brand / category searches.
      var byText = all.filter(function (p) {
        var hay = ((p.title || '') + ' ' + (p.vendor || '')).toLowerCase();
        return terms.every(function (t) { return hay.indexOf(t) > -1; });
      });
      // (b) stock-number match (task 86e2k37zy): customers search by a unit's SKU / model / barcode,
      // which lives in the variant SKU/barcode — NOT the title — so title-only matching missed them.
      // Ask Shopify's search WITH those fields, then keep only products that are in our in-stock index
      // (preserves in-stock-only + gives us card data + the dynamic rail). Degrades gracefully on error.
      var bySku = [];
      try {
        var su = new URL('/search/suggest.json', location.origin);
        su.searchParams.set('q', raw);
        su.searchParams.set('resources[type]', 'product');
        su.searchParams.set('resources[limit]', '10');
        su.searchParams.set('resources[options][unavailable_products]', 'last');
        su.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag');
        var sr = await fetch(su.toString());
        if (sr.ok) {
          var sj = await sr.json();
          var prods = (sj.resources && sj.resources.results && sj.resources.results.products) || [];
          var want = {};
          prods.forEach(function (p) { want['i' + p.id] = 1; if (p.handle) want['h' + p.handle] = 1; });
          bySku = all.filter(function (p) {
            var h = (p.url || '').split('/products/')[1] || '';
            return want['i' + p.id] || (h && want['h' + h]);
          });
        }
      } catch (e) { /* keyword results still stand */ }
      // union (keyword hits first), dedupe by product id.
      var seen = {}, out = [];
      byText.concat(bySku).forEach(function (p) { var k = 'x' + p.id; if (!seen[k]) { seen[k] = 1; out.push(p); } });
      return out;
    }
    // Fast path: condition/category collections scope straight from the index (no products.json fetch).
    // This is what makes huge collections like scratch-dent load instantly instead of paging thousands of members.
    var h = (COLLECTION_URL.split('/').pop() || '').toLowerCase();
    var condFam = /open-?box/.test(h) ? 'open' : /refurb/.test(h) ? 'refurb' : /scratch|dent/.test(h) ? 'scratch' : /new-appliance|new-in-box/.test(h) ? 'new' : null;
    var cat = catFromHandle(h);
    var catSet = cat ? (Array.isArray(cat) ? cat.map(lc) : [lc(cat)]) : null;   // one category, or a family (washers-dryers)
    // Universal rail (task): category & condition collections no longer HARD-scope the index — they load the FULL
    // catalog and PRE-SELECT this collection's category/condition instead (see preselect()), so a shopper can un-check
    // and browse every other category from any page (no dead ends / "we only stock this" impression). EXCEPTION:
    // curated & brand-scoped collections (forceMembership) fall through to the membership fetch below so they honour
    // their hand-picked / single-brand subset instead of showing the whole category. Brand/curated keep membership.
    if ((condFam || catSet) && !forceMembership(h)) return all;
    // Fallback: fetch membership for brand/curated collections that don't map to a condition/category.
    var ids = {}, page = 1, MAXP = 16, any = false;
    while (page <= MAXP) {
      var r;
      try { r = await fetch(COLLECTION_URL + '/products.json?limit=250&page=' + page); } catch (e) { break; }
      if (!r.ok) break;
      var j = await r.json();
      if (!j.products || !j.products.length) break;
      j.products.forEach(function (p) { ids[String(p.id)] = 1; any = true; });
      if (j.products.length < 250) break;
      page++;
    }
    if (!any) return all; // fallback: show full index rather than nothing
    return all.filter(function (it) { return ids[String(it.id)]; });
  }

  // Hero "N in stock" number (task 86e388kpf). It sits inside the ACTIVE category chip, so it must mean "how many
  // of THIS category we stock", not ITEMS.length, which on a category/condition collection is the WHOLE catalog
  // (the universal rail loads everything and PRE-SELECTS instead of hard-scoping, see scopeItems). That's why
  // /collections/washers-and-dryers read 742 while the grid showed 163. Counted from the collection's OWN identity
  // (handle-derived category/condition), NOT from checkbox state, so it holds steady while the shopper filters
  // further; the grid's "Showing X of N" line is what tracks live filtering.
  function heroBaseCount() {
    if (SCOPE !== 'collection') return ITEMS.length;            // catalog + search: the scoped set IS the answer
    var h = (COLLECTION_URL.split('/').pop() || '').toLowerCase();
    if (forceMembership(h)) return ITEMS.length;                // curated / brand: already hard-scoped by membership
    var cf = /open-?box/.test(h) ? 'open' : /refurb/.test(h) ? 'refurb' : /scratch|dent/.test(h) ? 'scratch' : /new-appliance|new-in-box/.test(h) ? 'new' : null;
    var cat = catFromHandle(h);
    if (!cf && !cat) return ITEMS.length;                       // all-appliances etc: no narrowing identity
    var conds = cf ? famCodes(cf).map(lc) : null;
    var cats = cat ? (Array.isArray(cat) ? cat : [cat]).map(lc) : null;
    var n = 0;
    for (var i = 0; i < ITEMS.length; i++) {
      var p = ITEMS[i];
      if (conds && !hasAny(p.f.condition, conds)) continue;
      if (cats && !hasAny(p.f.category, cats)) continue;
      n++;
    }
    return n;
  }

  Promise.all([
    fetch(root.getAttribute('data-index-url')).then(function (r) { return r.json(); }),
    fetch(root.getAttribute('data-tax-url')).then(function (r) { return r.json(); })
  ]).then(async function (res) {
    TAX = res[1];
    ITEMS = await scopeItems(res[0]);
    var heroN = document.getElementById('labHeroCount');
    if (heroN) {
      /* The hero must show the SAME figure as the grid's "of N", which is this index — not
         collection.products_count, which is live Shopify data and drifts by a few units because the
         index rebuilds on a 20-minute cron. Hand it to the slot reel when present so it lands
         rather than snapping; fall back to writing it directly. */
      var heroVal = heroBaseCount();
      if (window.NeuHeroCount && typeof window.NeuHeroCount.set === 'function') {
        window.NeuHeroCount.set(heroVal);
      } else {
        heroN.textContent = heroVal; heroN.removeAttribute('data-count-pending');
      }
    } // this collection's own in-stock count
    detectContext();
    buildRail();
    restoreFromUrl();
    preselect();
    updateVisibility();
    apply();
    announceTopVendors();
  }).catch(function () { countEl.textContent = 'Could not load products.'; });

  function cardHTML(p, condSel) {
    // Keep the badge consistent with an active condition filter: if the shopper filtered by a condition
    // this product matches, show THAT condition's badge instead of the default priority pick (avoids a
    // "New" filter showing a "Certified Refurb" badge on products tagged with both).
    var cond = p.cond, badge = p.badge;
    if (condSel && condSel.length && p.f.condition) {
      var pcl = p.f.condition.map(lc);
      for (var ci = 0; ci < condSel.length; ci++) { if (pcl.indexOf(condSel[ci]) > -1 && COND_LABEL[condSel[ci]]) { cond = COND_LABEL[condSel[ci]].cond; badge = COND_LABEL[condSel[ci]].label; break; } }
    }
    var bc = BADGE_C[cond] || { bc: 'var(--c-scratch)', bt: '#fff' };
    var img = p.img || FALLBACK;
    var hasCap = p.cap && p.cap > p.price;
    var off = hasCap ? Math.round((p.cap - p.price) / p.cap * 100) : 0;
    var save = hasCap ? ('You save ' + mtrim(p.cap - p.price)) : '';
    return '<article class="pcard" data-cond="' + esc(cond) + '">' +
      '<div class="pcard__media pcard__media--photo">' +
        (function () { var u = window.NEU_BADGE_URL && window.NEU_BADGE_URL(cond, badge); return u ? '<img class="pcard__badge-img" src="' + u + '" alt="' + esc(badge) + '" loading="lazy">' : ''; })() +
        '<a class="pcard__imglink" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '"><img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' + (p.img2 ? '<img class="pcard__img-alt" src="' + esc(p.img2) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">' : '') + '</a>' +
      '</div>' +
      '<div class="pcard__body">' +
        '<span class="pcard__brand">' + esc(p.vendor) + '</span>' +
        (p.model ? '<span class="pcard__model">' + esc(p.model) + '</span>' : '') +
        '<h3 class="pcard__title"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
        (p.sku ? '<div class="pcard__item">Item # ' + esc(p.sku) + '</div>' : '') +
        '<div class="pcard__price"><b>' + mtrim(p.price) + '</b>' + (hasCap ? '<s>' + mtrim(p.cap) + '</s><span class="pcard__off">' + off + '% OFF</span>' : '') + '</div>' +
        (save ? '<span class="pcard__save">' + save + '</span>' : '') +
        '<div class="pcard__actions"><a class="btn btn--navy pcard__shop" href="' + esc(p.url) + '">Shop Now</a></div>' +
      '</div></article>';
  }

  function selected(grp) { return [].slice.call(filterRoot.querySelectorAll('input[data-fgroup="' + grp + '"]:checked')).map(function (i) { return i.value; }); }
  function countFor(dim, code) { var n = 0, x = lc(code); for (var i = 0; i < ITEMS.length; i++) { var v = ITEMS[i].f[dim]; if (v) { for (var j = 0; j < v.length; j++) { if (lc(v[j]) === x) { n++; break; } } } } return n; }
  function vendorCounts() { var m = {}; ITEMS.forEach(function (p) { if (p.vendor) m[p.vendor] = (m[p.vendor] || 0) + 1; }); return m; }
  // Sub-brand fold for the BRAND ROW ONLY (the sidebar Manufacturer filter above keeps raw vendors via vendorCounts()).
  // A "shop by brand" tile should show the parent marque, so fold known marketing sub-lines into their parent brand.
  var BRAND_PARENT = {
    'ge profile': 'GE', 'ge café': 'GE', 'ge cafe': 'GE', 'café': 'GE', 'cafe': 'GE', 'monogram': 'GE', 'ge monogram': 'GE', 'ge appliances': 'GE', 'hotpoint': 'GE',
    'frigidaire gallery': 'Frigidaire', 'frigidaire professional': 'Frigidaire',
    'lg signature': 'LG', 'lg studio': 'LG',
    'samsung bespoke': 'Samsung',
    'whirlpool gold': 'Whirlpool',
    'maytag commercial': 'Maytag',
    'coyte': 'Coyote'
  };
  function brandParent(v) { return BRAND_PARENT[lc(v)] || v; }
  // task: expose the top brands so the auto-filter row can append brand tiles. Use `filtered` (this collection's initial
  // pre-selected view) not the whole index — the universal rail now loads the full catalog into ITEMS, so ITEMS is
  // global; `filtered` keeps the brand tiles relevant to the page (e.g. fridge brands on /refrigerators). Runs once at
  // init right after the first apply(), so `filtered` = the collection's default result.
  function announceTopVendors() {
    var m = {}, img = {}, kids = {};
    (filtered.length ? filtered : ITEMS).forEach(function (p) {
      if (!p.vendor) return;
      var c = brandParent(p.vendor);
      m[c] = (m[c] || 0) + 1;
      if (!img[c] && p.img) img[c] = p.img;
      (kids[c] = kids[c] || {})[p.vendor] = 1;   // remember the raw vendors folded under this parent (for the tile's filter)
    });
    var top = Object.keys(m).sort(function (a, b) { return m[b] - m[a] || String(a).localeCompare(b); }).slice(0, 8)
      .map(function (v) { return { vendor: v, count: m[v], img: img[v] || '', vendors: Object.keys(kids[v]) }; });
    window.NEU_TOP_VENDORS = top;
    try { document.dispatchEvent(new CustomEvent('neu:vendors', { detail: top })); } catch (e) {}
  }
  function opt(grp, value, label, count) { return '<label class="neu-filters__opt"><input type="checkbox" data-fgroup="' + esc(grp) + '" value="' + esc(value) + '"><span class="neu-filters__opt-label">' + esc(label) + '</span><span class="neu-filters__opt-count">' + (count || 0) + '</span></label>'; }
  function group(title, rows, isOpen, attrs) { if (!rows) return ''; return '<details class="neu-filters__group"' + (isOpen ? ' open' : '') + (attrs || '') + '><summary class="neu-filters__group-title">' + esc(title) + '<span class="neu-filters__plus"></span></summary><div class="neu-filters__group-body">' + rows + '</div></details>'; }

  var singleCat = null, singleCondFam = null;
  function famOf(code) { code = lc(code); if (code.indexOf('sd') === 0) return 'scratch'; if (code === 'ob') return 'open'; if (code === 'cr') return 'refurb'; if (code === 'new') return 'new'; return null; }
  function famCodes(fam) { return fam === 'open' ? ['ob'] : fam === 'refurb' ? ['cr'] : fam === 'new' ? ['new'] : fam === 'scratch' ? ['sdmin', 'sdmod', 'sdmaj'] : []; }
  // Adapt the rail to the collection with no per-collection config:
  //   single category  -> category page: hide the Category parent, show that category's sub-filters directly
  //   single condition -> condition page: hide the Condition group (redundant here)
  function detectContext() {
    // Category: from the scoped products (robust — category isn't double-tagged).
    var catC = {}, nCat = 0;
    ITEMS.forEach(function (p) { var cs = p.f.category || []; if (cs.length) { nCat++; cs.forEach(function (c) { catC[c] = (catC[c] || 0) + 1; }); } });
    var cats = Object.keys(catC); if (cats.length) { cats.sort(function (a, b) { return catC[b] - catC[a]; }); if (cats.length === 1 || catC[cats[0]] / nCat >= 0.9) singleCat = cats[0]; }
    // Condition family: the universal rail (task) keeps the Condition group visible on condition collections too — it's
    // PRE-SELECTED via preselect(), not hidden — so we no longer force singleCondFam from the handle (that hid the group).
    // Only set it when the SCOPED set is unambiguously one family (brand/curated membership), for the badge fallback.
    if (!singleCondFam) {
      var famC = {}; ITEMS.forEach(function (p) { var fams = {}; (p.f.condition || []).forEach(function (c) { var fm = famOf(c); if (fm) fams[fm] = 1; }); Object.keys(fams).forEach(function (fm) { famC[fm] = (famC[fm] || 0) + 1; }); });
      var fams = Object.keys(famC); if (fams.length === 1) singleCondFam = fams[0];
    }
  }

  function buildRail() {
    var G = TAX.globals, L = TAX.dimLabels, CATS = TAX.categories;
    var html = '<div class="neu-filters__bar"><span class="neu-filters__heading">Filter</span><button type="button" class="neu-filters__clear" data-lab-clear>Clear all</button></div>';
    html += '<div class="neu-filters__active" data-lab-active hidden></div>';   // removable active-filter pills
    // SOP rule 1: the rail ALWAYS shows every filter group (Condition, Category + all category sub-filters) regardless of
    // which collection we're on — visibility never depends on the page. singleCat/singleCondFam no longer hide groups
    // here; the page expresses itself only via pre-selection / membership scope, never by hiding a group.
    html += group(L.condition || 'Condition', G.condition.map(function (o) { return opt('condition', o[0], o[1], countFor('condition', o[0])); }).join(''), true);
    html += group(L.category || 'Category', G.category.map(function (o) { return opt('category', o[0], o[1], countFor('category', o[0])); }).join(''), true);
    var catsToShow = Object.keys(CATS);
    catsToShow.forEach(function (cat) {
      var dims = CATS[cat]; if (!dims) return;
      Object.keys(dims).forEach(function (dimKey) {
        var rows = dims[dimKey].map(function (o) { return opt(dimKey, o[0], o[1], countFor(dimKey, o[0])); }).join('');
        // data-sub marks sub-dim groups for filtering; data-pcat drives the cascade (sub-group shows once its category is selected)
        var attrs = ' data-sub="1" data-pcat="' + esc(cat) + '"';
        html += group(L[dimKey] || dimKey, rows, true, attrs);
      });
    });
    var vc = vendorCounts();
    html += group('Manufacturer', Object.keys(vc).sort().map(function (v) { return opt('vendor', v, v, vc[v]); }).join(''));
    html += group(L.color || 'Color', G.color.map(function (o) { return opt('color', o[0], o[1], countFor('color', o[0])); }).join(''));
    html += group(L.location || 'Location', G.location.map(function (o) { return opt('location', o[0], o[1], countFor('location', o[0])); }).join(''));
    html += '<details class="neu-filters__group"><summary class="neu-filters__group-title">Price<span class="neu-filters__plus"></span></summary><div class="neu-filters__group-body"><div class="neu-filters__price"><label>Min <input type="number" inputmode="decimal" id="labMin" min="0" placeholder="0"></label><label>Max <input type="number" inputmode="decimal" id="labMax" min="0" placeholder="max"></label></div></div></details>';
    html += '<button type="button" class="btn btn--gold btn--full neu-filters__apply" data-lab-clear>Reset filters</button>';
    filterRoot.innerHTML = html;
    updateVisibility();
    // task 86e3173gn: applying a filter re-renders the grid; the old approach tried to FREEZE the previous
    // scroll position, which clamp-jumped when the result set shrank (you'd end up stranded at the new bottom).
    // Instead, a filter change resets to page 1 and scrolls the top of the results under the sticky header —
    // predictable, and it's what shoppers expect after filtering. scrollResultsTop() lives at module scope.
    filterRoot.addEventListener('change', function (e) { if (e.target.matches('input[type="checkbox"]')) { page = 1; updateVisibility(); apply(); scrollResultsTop(); } });
    // Price typing: debounce so we don't re-filter on every keystroke (typing "5000" would otherwise filter at
    // 5, 50, 500... each reflow reshuffling the grid — task 86e3173gn), then apply from page 1.
    var priceTimer;
    filterRoot.addEventListener('input', function (e) { if (e.target.id === 'labMin' || e.target.id === 'labMax') { clearTimeout(priceTimer); priceTimer = setTimeout(function () { page = 1; apply(); scrollResultsTop(); }, 350); } });
    filterRoot.addEventListener('click', function (e) {
      if (e.target.closest('[data-lab-clear]')) { clearAll(e); return; }
      var pill = e.target.closest('.neu-filters__pill');
      if (pill) {
        var g = pill.getAttribute('data-fg'), v = pill.getAttribute('data-fv');
        var inp = [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]')).filter(function (i) { return i.getAttribute('data-fgroup') === g && i.value === v; })[0];
        if (inp) { inp.checked = false; page = 1; updateVisibility(); apply(); scrollResultsTop(); }
      }
    });
  }
  // Sub-dimension groups appear/disappear as categories are (de)selected. Animate that (fade/slide) instead of an
  // instant display:none flip. The FIRST pass (initial rail build) sets display with no animation, so hidden groups
  // don't flash-fade on load. Uncheck of a hidden group's inputs stays synchronous (so apply() sees it immediately).
  var visReady = false;
  function updateVisibility() {
    var selCats = selected('category');
    [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-pcat]')).forEach(function (g) {
      var visible = selCats.indexOf(g.getAttribute('data-pcat')) > -1;
      var shown = g.style.display !== 'none';
      if (!visible) [].slice.call(g.querySelectorAll('input:checked')).forEach(function (i) { i.checked = false; });
      if (prefersReduced || !visReady) { g.style.display = visible ? '' : 'none'; return; }
      if (visible && !shown) { g.style.display = ''; g.classList.remove('neu-fg-out'); g.classList.add('neu-fg-in'); setTimeout(function () { g.classList.remove('neu-fg-in'); }, 340); }
      else if (!visible && shown) { g.classList.add('neu-fg-out'); setTimeout(function () { g.style.display = 'none'; g.classList.remove('neu-fg-out'); }, 210); }
      else if (!visible) { g.style.display = 'none'; }
    });
    visReady = true;
  }
  function activeSubDimSelections() {
    var sel = {};
    [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-sub]')).forEach(function (g) {
      if (g.style.display === 'none') return;
      [].slice.call(g.querySelectorAll('input[data-fgroup]:checked')).forEach(function (i) { var k = i.getAttribute('data-fgroup'); (sel[k] = sel[k] || []).push(lc(i.value)); });
    });
    return sel;
  }
  function hasAny(itemVals, wanted) { if (!itemVals) return false; for (var i = 0; i < itemVals.length; i++) if (wanted.indexOf(lc(itemVals[i])) > -1) return true; return false; }

  // Filter state in the URL: fixes back-nav (browser restores the filtered view) + makes filtered pages shareable.
  var URL_KEEP = ['preview_theme_id', 'filter.v.availability', '_fd', '_ab', '_sc', 'pb', 'q', 'type'];
  function syncUrl() {
    var params = new URLSearchParams();
    var groups = {};
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]:checked')).forEach(function (i) { var g = i.getAttribute('data-fgroup'); (groups[g] = groups[g] || []).push(i.value); });
    Object.keys(groups).forEach(function (g) { params.set(g, groups[g].join(',')); });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI && minI.value) params.set('min', minI.value);
    if (maxI && maxI.value) params.set('max', maxI.value);
    if (sortSel && sortSel.value && sortSel.value !== 'prio') params.set('sort', sortSel.value);  // keep the chosen sort across back-nav / sharing (prio = default, left out to keep URLs clean)
    if (page > 1) params.set('page', page);   // task 86e33ndh5: paginated view is shareable + survives back-nav
    var cur = new URLSearchParams(location.search);
    URL_KEEP.forEach(function (k) { if (cur.has(k)) params.set(k, cur.get(k)); });
    var qs = params.toString();
    try { history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '')); } catch (e) {}
  }
  function restoreFromUrl() {
    var params = new URLSearchParams(location.search);
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]')).forEach(function (i) {
      var g = i.getAttribute('data-fgroup');
      if (params.has(g) && params.get(g).split(',').indexOf(i.value) > -1) i.checked = true;
    });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI && params.has('min')) minI.value = params.get('min');
    if (maxI && params.has('max')) maxI.value = params.get('max');
    if (sortSel && params.has('sort')) { var sv = params.get('sort'); if ([].some.call(sortSel.options, function (o) { return o.value === sv; })) sortSel.value = sv; }
    var pg = parseInt(params.get('page'), 10); if (pg > 1) page = pg;   // task 86e33ndh5: restore the page number
  }
  // Universal rail (task): on a fresh collection load (no category/condition yet in the URL), PRE-CHECK this collection's
  // own category/condition so the initial view matches the page — then apply()->syncUrl() writes it into the URL, making
  // the state explicit + shareable + restorable on back/forward. A URL that already carries category/condition (a shared
  // link or a de-selection the shopper made) is respected and never overridden. Catalog/search/brand pages don't preselect.
  function preselect() {
    if (SCOPE !== 'collection') return;
    var params = new URLSearchParams(location.search);
    if (params.has('category') || params.has('condition')) return;
    var h = (COLLECTION_URL.split('/').pop() || '').toLowerCase();
    // Curated / brand-scoped collections are already scoped to their membership — don't also pre-check a broad category.
    if (forceMembership(h)) return;
    function check(grp, codes) {
      var inputs = [].slice.call(filterRoot.querySelectorAll('input[data-fgroup="' + grp + '"]'));
      codes.forEach(function (code) { var lcC = lc(code); inputs.forEach(function (i) { if (lc(i.value) === lcC) i.checked = true; }); });
    }
    var cf = /open-?box/.test(h) ? 'open' : /refurb/.test(h) ? 'refurb' : /scratch|dent/.test(h) ? 'scratch' : /new-appliance|new-in-box/.test(h) ? 'new' : null;
    if (cf) check('condition', famCodes(cf));
    var cat = catFromHandle(h);
    if (cat) check('category', Array.isArray(cat) ? cat : [cat]);
  }

  function subDimKeys() { var s = {}; [].slice.call(filterRoot.querySelectorAll('details.neu-filters__group[data-sub] input[data-fgroup]')).forEach(function (i) { s[i.getAttribute('data-fgroup')] = 1; }); return Object.keys(s); }
  function currentSel() {
    var sel = {};
    ['condition', 'category', 'color', 'location'].forEach(function (g) { var v = selected(g).map(lc); if (v.length) sel[g] = v; });
    var ven = selected('vendor'); if (ven.length) sel.vendor = ven;
    var sub = activeSubDimSelections(); for (var k in sub) sel[k] = sub[k];
    return sel;
  }
  function matchesSel(p, sel, except, lo, hi) {
    if (except !== 'price' && (p.price < lo || p.price > hi)) return false;
    for (var d in sel) { if (d === except) continue; if (d === 'vendor') { if (sel[d].indexOf(p.vendor) < 0) return false; } else if (!hasAny(p.f[d], sel[d])) return false; }
    return true;
  }
  // Disjunctive facet counts: each option shows how many products it would yield given the OTHER active
  // filters, so counts recalc as you select (like Kidsy). Zero-yield options are greyed + disabled — this
  // also removes the "count says 2 but 0 results" mismatch, because the count is now the real result count.
  function updateCounts() {
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    var lo = parseFloat(minI && minI.value) || 0, hi = parseFloat(maxI && maxI.value) || Infinity;
    var sel = currentSel();
    var dims = ['condition', 'category', 'color', 'location', 'vendor'].concat(subDimKeys());
    var counts = {}; dims.forEach(function (d) { counts[d] = {}; });
    ITEMS.forEach(function (p) {
      dims.forEach(function (d) {
        if (!matchesSel(p, sel, d, lo, hi)) return;
        var vals = d === 'vendor' ? (p.vendor ? [p.vendor] : []) : (p.f[d] || []);
        vals.forEach(function (v) { var key = d === 'vendor' ? v : lc(v); counts[d][key] = (counts[d][key] || 0) + 1; });
      });
    });
    [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]')).forEach(function (i) {
      var d = i.getAttribute('data-fgroup'), key = d === 'vendor' ? i.value : lc(i.value);
      var n = (counts[d] && counts[d][key]) || 0;
      var lab = i.closest('.neu-filters__opt'); if (!lab) return;
      var span = lab.querySelector('.neu-filters__opt-count'); if (span) span.textContent = n;
      var dead = n === 0 && !i.checked;
      i.disabled = dead; lab.classList.toggle('neu-filters__opt--empty', dead);
    });
  }
  // Active-filter pills under the "Filter" heading — each removable; removing de-selects that filter.
  function renderActivePills() {
    var wrap = filterRoot.querySelector('[data-lab-active]');
    if (!wrap) return;
    var checked = [].slice.call(filterRoot.querySelectorAll('input[data-fgroup]:checked'));
    if (!checked.length) { wrap.innerHTML = ''; wrap.hidden = true; return; }
    wrap.hidden = false;
    wrap.innerHTML = checked.map(function (i) {
      var o = i.closest('.neu-filters__opt'), lab = o && o.querySelector('.neu-filters__opt-label');
      var text = lab ? lab.textContent : i.value;
      return '<button type="button" class="neu-filters__pill" data-fg="' + esc(i.getAttribute('data-fgroup')) + '" data-fv="' + esc(i.value) + '"><span class="neu-filters__pill-t">' + esc(text) + '</span><span class="neu-filters__pill-x" aria-hidden="true">×</span></button>';
    }).join('');
  }
  function apply() {
    var fCond = selected('condition').map(lc), fCat = selected('category').map(lc), fCol = selected('color').map(lc), fLoc = selected('location').map(lc), fVen = selected('vendor');
    var sub = activeSubDimSelections();
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    var lo = parseFloat(minI && minI.value) || 0, hi = parseFloat(maxI && maxI.value) || Infinity;
    filtered = ITEMS.filter(function (p) {
      if (fCond.length && !hasAny(p.f.condition, fCond)) return false;
      if (fCat.length && !hasAny(p.f.category, fCat)) return false;
      if (fCol.length && !hasAny(p.f.color, fCol)) return false;
      if (fLoc.length && !hasAny(p.f.location, fLoc)) return false;
      if (fVen.length && fVen.indexOf(p.vendor) < 0) return false;
      for (var k in sub) { if (sub[k].length && !hasAny(p.f[k], sub[k])) return false; }
      if (p.price < lo || p.price > hi) return false;
      return true;
    });
    sortFiltered(); render(); syncUrl(); updateCounts(); renderActivePills();
  }
  // "Outlet Appliances" default sort (clients 86e1zc7xe + 86e27z1mb):
  //  1) CONDITION first: Scratch & Dent -> Open Box -> Certified Refurb -> New in Box (last).
  //  2) WITHIN each condition: a RANDOM mix of the desirable products up top (shuffle key item.rnd, baked
  //     per index build so it's stable per rebuild ~20 min), then Discount_LIQ items, then the low-value
  //     small-appliance styles + untagged leftovers at the bottom of that condition's block.
  // "High value" here means desirable-by-style, NOT price — the client rejected a price sort (looked too high-end).
  var LOVAL_ALWAYS = { mini: 1, wine: 1, allref: 1, bev: 1 };   // REF mini / wine / all-fridge / beverage: always low-value
  var LOVAL_CHEAPFRZ = { chest: 1, stuf: 1 };                    // chest / standup freezers: only when under $500
  function isLowValue(p) {
    var st = (p.f && p.f.style) || [];
    for (var i = 0; i < st.length; i++) {
      var s = lc(st[i]);
      if (LOVAL_ALWAYS[s]) return true;
      if (LOVAL_CHEAPFRZ[s] && (p.price || 0) < 500) return true;
    }
    return false;
  }
  function condTier(p) { var c = lc(p.cond || ''); if (c === 'open') return 1; if (c === 'refurb') return 2; if (c === 'new') return 3; return 0; } // scratch + untagged -> first
  function subTier(p) {
    var c = lc(p.cond || '');
    var known = (c === 'scratch' || c === 'open' || c === 'refurb' || c === 'new');
    if (p.liq) return 1;                       // Discount_LIQ -> middle of the block
    if (isLowValue(p) || !known) return 2;     // low-value styles + untagged/leftover -> bottom of the block
    return 0;                                  // desirable products -> random top of the block
  }
  function sortFiltered() {
    var s = sortSel.value;
    filtered.sort(function (a, b) {
      if (s === 'price-asc') return a.price - b.price || a.prio - b.prio;
      if (s === 'price-desc') return b.price - a.price || a.prio - b.prio;
      if (s === 'title') return a.title.localeCompare(b.title);
      if (s === 'recent') return (b.added || 0) - (a.added || 0) || a.prio - b.prio; // newest first (task 86e26y4c9)
      // default "Outlet Appliances": condition (S&D -> Open Box -> Refurb -> New) then within each block: random mix -> LIQ -> low-value/leftover.
      return condTier(a) - condTier(b) || subTier(a) - subTier(b) || (a.rnd || 0) - (b.rnd || 0) || a.price - b.price;
    });
  }
  // ---- scroll + numbered pagination (task 86e3173gn scroll-jump + task 86e33ndh5 pagination) ----
  function scrollBox() {
    var sc = document.querySelector('.page-wrapper');
    if (sc && sc.scrollHeight > sc.clientHeight + 4) return sc;
    var el = root;
    while (el && el !== document.documentElement) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 4) return el;
      el = el.parentElement;
    }
    return null;
  }
  // Scroll the top of the results (the sort/count bar) to just under the sticky header — predictable, never the
  // old clamp-jump. This theme's desktop scroll container is a nested .page-wrapper with CSS scroll-behavior:smooth,
  // which makes a behavior:'smooth' scrollTo a no-op — so we use behavior:'instant' (exactly what the theme's own
  // scroll-restoration does) to reliably snap to the results. Falls back to the window when there's no container.
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // rAF smooth-scroll: setting scrollTop per frame animates reliably even though this theme's .page-wrapper has
  // CSS scroll-behavior:smooth (which no-ops scrollTo({behavior:'smooth'})). Reduced-motion / tiny distance snaps.
  var scrollRAF;
  function smoothScrollTo(sc, targetTop) {
    targetTop = Math.max(0, targetTop);
    if (sc) targetTop = Math.min(targetTop, Math.max(0, sc.scrollHeight - sc.clientHeight));  // never past the content
    if (scrollRAF) cancelAnimationFrame(scrollRAF);
    var getY = function () { return sc ? sc.scrollTop : (window.pageYOffset || document.documentElement.scrollTop); };
    var setY = function (y) { if (sc) sc.scrollTop = y; else window.scrollTo(0, y); };
    var start = getY(), dist = targetTop - start;
    // Snap instantly for reduced-motion, tiny moves, OR big jumps like paging from the bottom pager:
    // a long animation drags the scroll up through the grid content-visibility placeholders as they paint,
    // so it overshoots and lands at the bottom (task 86e3173gn back-nav jump).
    if (prefersReduced || Math.abs(dist) < 4 || Math.abs(dist) > 2400) { setY(targetTop); return; }
    var dur = Math.min(700, Math.max(320, Math.abs(dist) * 0.5)), t0 = null;
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);   // easeOutCubic
      setY(start + dist * e);
      if (p < 1) scrollRAF = requestAnimationFrame(step);
    }
    scrollRAF = requestAnimationFrame(step);
  }
  function scrollResultsTop() {
    var HEADER = 100;
    var sc = scrollBox(), r = root.getBoundingClientRect();
    var target = (sc ? sc.scrollTop - sc.getBoundingClientRect().top : (window.pageYOffset || document.documentElement.scrollTop)) + r.top - HEADER;
    smoothScrollTo(sc, target);
  }
  function goToPage(n) {
    var tp = Math.max(1, Math.ceil(filtered.length / PER));
    n = Math.min(Math.max(1, n), tp);
    if (n === page) return;
    page = n; render(); syncUrl(); scrollResultsTop();
  }
  var pagerBottom;
  function ensurePagers() {
    if (pagerBottom) return;
    if (moreBtn) { var mc = moreBtn.parentNode; if (mc && mc !== grid.parentNode) mc.style.display = 'none'; else moreBtn.style.display = 'none'; } // retire the old "Load more"
    // Bottom pagination only — the top pager was removed (page changes jump to the top of results, so a top pager is redundant).
    pagerBottom = document.createElement('nav'); pagerBottom.className = 'neu-pager neu-pager--bottom'; pagerBottom.setAttribute('aria-label', 'Pagination');
    grid.parentNode.insertBefore(pagerBottom, grid.nextSibling);
    pagerBottom.addEventListener('click', function (e) { var b = e.target.closest('button[data-page]'); if (b && !b.disabled) goToPage(parseInt(b.getAttribute('data-page'), 10)); });
  }
  function pageList(cur, total) {   // compact list with ellipses: 1 … c-1 c c+1 … total
    var out = [], i;
    if (total <= 7) { for (i = 1; i <= total; i++) out.push(i); return out; }
    out.push(1);
    var lo = Math.max(2, cur - 1), hi = Math.min(total - 1, cur + 1);
    if (lo > 2) out.push('…');
    for (i = lo; i <= hi; i++) out.push(i);
    if (hi < total - 1) out.push('…');
    out.push(total);
    return out;
  }
  function pagerHTML(total) {
    if (total <= 1) return '';
    var h = '<button type="button" class="neu-pager__btn neu-pager__nav" data-page="' + (page - 1) + '"' + (page <= 1 ? ' disabled' : '') + ' aria-label="Previous page">‹</button>';
    pageList(page, total).forEach(function (n) {
      if (n === '…') { h += '<span class="neu-pager__gap" aria-hidden="true">…</span>'; return; }
      h += '<button type="button" class="neu-pager__btn neu-pager__num' + (n === page ? ' is-active' : '') + '" data-page="' + n + '"' + (n === page ? ' aria-current="page"' : '') + '>' + n + '</button>';
    });
    h += '<button type="button" class="neu-pager__btn neu-pager__nav" data-page="' + (page + 1) + '"' + (page >= total ? ' disabled' : '') + ' aria-label="Next page">›</button>';
    return h;
  }
  function renderPagers(total) {
    ensurePagers();
    var html = pagerHTML(total);
    pagerBottom.innerHTML = html;
    pagerBottom.hidden = !html;
  }
  // Staggered fade-rise entrance, replayed on every render (filter / page / sort / initial). Removing then re-adding
  // the class (with a forced reflow) restarts the CSS animation; the per-card --pc-i (capped at 11) makes it a quick
  // cascade that never feels slow. Class is dropped after the run so content-visibility reveals below the fold don't re-fire it.
  var animTimer;
  function playGridEntrance() {
    if (prefersReduced) return;
    var cards = grid.children;
    for (var i = 0; i < cards.length; i++) { if (cards[i].style) cards[i].style.setProperty('--pc-i', Math.min(i, 11)); }
    grid.classList.remove('is-animating'); void grid.offsetWidth; grid.classList.add('is-animating');
    clearTimeout(animTimer); animTimer = setTimeout(function () { grid.classList.remove('is-animating'); }, 1100);
  }
  function render() {
    // Badge follows the active condition filter; on a condition page (no filter, Condition hidden)
    // it follows the page's condition so an Open Box page shows "Open Box", not the default S&D pick.
    var condSel = selected('condition').map(lc);
    if (!condSel.length && singleCondFam) condSel = famCodes(singleCondFam);
    var total = filtered.length;
    var tp = Math.max(1, Math.ceil(total / PER));
    if (page > tp) page = tp;
    if (page < 1) page = 1;
    var start = (page - 1) * PER;
    var slice = filtered.slice(start, start + PER);
    grid.innerHTML = slice.map(function (p) { return cardHTML(p, condSel); }).join('');
    if (window.neuFillStars) window.neuFillStars(grid);   // fill card stars (rendered after the initial pass)
    countEl.innerHTML = total ? ('Showing <b>' + (start + 1) + '–' + (start + slice.length) + '</b> of <b>' + total + '</b> products') : 'No products';
    emptyEl.hidden = total > 0;
    renderPagers(tp);
    playGridEntrance();
  }
  function clearAll(e) {
    if (e) e.preventDefault();
    filterRoot.querySelectorAll('input[type="checkbox"]').forEach(function (i) { i.checked = false; });
    var minI = document.getElementById('labMin'), maxI = document.getElementById('labMax');
    if (minI) minI.value = ''; if (maxI) maxI.value = '';
    page = 1; updateVisibility(); apply(); scrollResultsTop();
  }
  sortSel.addEventListener('change', function () { page = 1; sortFiltered(); render(); syncUrl(); scrollResultsTop(); });
  // task 86e33ndh5: "Load more" replaced by numbered pagination (renderPagers / goToPage); #labMore is retired in ensurePagers().
  emptyEl.addEventListener('click', function (e) { if (e.target.closest('[data-lab-clear]')) clearAll(e); });
  var toggle = root.querySelector('[data-lab-toggle]'), fwrap = root.querySelector('.shop__filters');
  if (toggle && fwrap) toggle.addEventListener('click', function () { fwrap.classList.toggle('is-open'); });
  var view = root.querySelector('.shop__view');
  if (view) view.addEventListener('click', function (e) { var b = e.target.closest('.shop__view-btn'); if (!b) return; view.querySelectorAll('.shop__view-btn').forEach(function (x) { x.classList.remove('is-active'); }); b.classList.add('is-active'); grid.classList.toggle('is-list', b.getAttribute('data-view') === 'list'); });
})();
